<div mat-dialog-content class="dialog-tarefas-etiquetas__conteudo">
  <app-lista-dados [upTitulo]="'Etiquetas'" [upIcone]="'sell'" [upCor]="'1565C0'" [upDados]="etiquetas"
    [upColunas]="colunas" [upLargura]="3" [upHabilitaContador]="true" [upHabilitaBotaoIncluir]="true"
    [upHabilitaBotaoEditar]="true" [upHabilitaBotaoExcluir]="true" (ueBotaoIncluir)="abrirEtiqueta()"
    (ueBotaoEditar)="abrirEtiqueta($event)" (ueBotaoExcluir)="removerEtiqueta($event)">
  </app-lista-dados>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" type="button" (click)="fechar()">Fechar</button>
</div>